module.exports = __webpack_public_path__ + "img/Whatsapp Widget.4283b4b0.png";